import React, { Component } from 'react'
import './CustomerTextHistory.css'
import { motion } from 'framer-motion'
import {backdropTransition, popupTransition, transitionDuration} from '../../../../../../../../Util/PageTransitions'
import axios from 'axios'

export default class CustomerTextHistory extends Component {
    constructor() {
        super()
        this.state = {
            message: ''
        }
    }

    componentDidMount() {
        this.scrollToBottom()
    }

    componentDidUpdate() {
        this.scrollToBottom()
    }

    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "auto" })
    }

    sendMessageHandler = () => {
        axios.get(`${this.props.route}/api/sendSMS?recipient=${this.props.customerInfo.phoneNumber}&textmessage=${this.state.message}`)
        .then(() => {
            
        })
        .catch(() => {
            this.props.displayMessageHandler('Message Failed to Send')
        })
    }

    formatDateHandler = (date) => {
        let formattedDate = new Date(date)
        let day = formattedDate.getDate()
        let month = formattedDate.getMonth() + 1
        let year = formattedDate.getFullYear()
        let hours = formattedDate.getHours()
        let minutes = formattedDate.getMinutes()
        let dayPeriod = ''
        
        if (hours === 0) {
            hours = 12
        } else if (hours < 12) {
            dayPeriod = 'AM'
        } else if (hours === 12) {
            dayPeriod = 'PM'
        } else {
            hours -= 12
            dayPeriod = 'PM'
        }
        return `${month}/${day}/${year} - ${hours}:${minutes < 10 ? `0${minutes}` : minutes} ${dayPeriod}`
    }

    render() {
        return (
            <div className='customerTextHistoryPageContainer'>
                <motion.div className='customerTextHistoryBackdrop' onClick={this.props.closeDisplay} initial={backdropTransition.initial} animate={backdropTransition.in} exit={backdropTransition.out} transition={{ duration: transitionDuration }}/>
                <motion.div className='customerTextHistoryContainer' initial={popupTransition.initial} animate={popupTransition.in} exit={popupTransition.out} transition={{ duration: transitionDuration }}>
                    <div className='customerTextHistoryHeaderContainer'>
                        <h1 className='customerTextHistoryHeaderText'>{this.props.customerInfo.name}</h1>
                        <button className='customerTextHistoryCloseButton' onClick={this.props.closeDisplay}/>
                    </div>
                    <div className='customerTextHistoryBodyContainer'>
                        {this.props.textHistory?.map((value, index) => (
                            <div className='customerTextHistoryMessageWrapper' key={index}>
                                <div className='customerTextHistoryMessageContainer'>
                                    <p className='customerTextHistoryMessageText'>{value.message}</p>
                                </div>
                                <p className='customerTextHistoryMessageTime'>{this.formatDateHandler(value.date)}</p>
                            </div>
                        ))}
                        <div className='customerTextHistoryBottomAnchor' ref={(el) => { this.messagesEnd = el }} />
                    </div>
                    <div className='customerTextHistoryFooterContainer'>
                        <textarea value={this.state.message} onChange={(e) => this.setState({message: e.target.value})} className='customerTextHistoryMessageInput'></textarea>
                        <button className='customerTextHistorySendButton' onClick={this.sendMessageHandler}>Send</button>
                    </div>
                </motion.div>
            </div>
        )
    }
}
